import httpClient from 'utility/httpClient.util'
import {
  mergeRequireOptionConfig,
  REQUIRE_OPTION_CONFIG_CODE,
} from './config'

const pendingRequests = {}

const unwrapConfig = (response) =>
  response?.data?.data || response?.data || response || null

export const loadRequireConfig = async (configCode, { refresh = false } = {}) => {
  if (!refresh && pendingRequests[configCode]) {
    return pendingRequests[configCode]
  }

  const request = httpClient
    .get(`/core/config/configCode/${configCode}`)
    .then(unwrapConfig)
    .catch((error) => {
      if (error?.response?.status === 404) return null
      throw error
    })
    .finally(() => {
      delete pendingRequests[configCode]
    })

  pendingRequests[configCode] = request
  return request
}

export const saveRequireOptionConfig = async ({ scopeKey, pending }) => {
  const remoteConfig =
    (await loadRequireConfig(REQUIRE_OPTION_CONFIG_CODE, { refresh: true })) ||
    { configCode: REQUIRE_OPTION_CONFIG_CODE, jsonData: {} }
  const nextConfig = mergeRequireOptionConfig({
    config: remoteConfig,
    scopeKey,
    pending,
  })

  await httpClient.put(
    `/core/config/configCode/${REQUIRE_OPTION_CONFIG_CODE}`,
    nextConfig,
  )
  return nextConfig
}
